import apiClient from '@/services/rest-api-sms/apiClient'

const baseEndpoint = '/custom-profile'

const regionHeaders = (serverRegion) => serverRegion ? { 'X-Region': serverRegion } : undefined

export const get = async (queryParam = {}, serverRegion) => {
  const params = {
    page: queryParam.page || undefined,
    limit: queryParam.limit || queryParam.size || undefined,
    sorts: queryParam.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam.search || queryParam.q || undefined,
    filters: queryParam.filters || undefined,
  }

  const response = await apiClient({
    method: 'GET',
    url: baseEndpoint,
    headers: regionHeaders(serverRegion),
    params,
  })

  return response?.data
}

export const create = async (payload, serverRegion) => {
  const response = await apiClient({
    method: 'POST',
    url: baseEndpoint,
    headers: regionHeaders(serverRegion),
    data: payload,
  })

  return response?.data
}

export const update = async (profileId, payload, serverRegion) => {
  const response = await apiClient({
    method: 'PATCH',
    url: `${baseEndpoint}/${profileId}`,
    headers: regionHeaders(serverRegion),
    data: payload,
  })

  return response?.data
}

export const updateVehicleProfile = async (vehicleId, payload, serverRegion) => {
  const response = await apiClient({
    method: 'PATCH',
    url: `${baseEndpoint}/vehicle/${vehicleId}`,
    headers: regionHeaders(serverRegion),
    data: payload,
  })

  return response?.data
}

export const checkProfile = async (vehicleId, payload, serverRegion) => {
  const response = await apiClient({
    method: 'POST',
    url: `${baseEndpoint}/vehicle/${vehicleId}`,
    headers: regionHeaders(serverRegion),
    data: payload,
  })

  return response?.data
}

export const getCheckProfile = async (vehicleId, queryParam = {}, serverRegion) => {
  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}/vehicle/${vehicleId}`,
    headers: regionHeaders(serverRegion),
    params: {
      type: queryParam.type || undefined,
      status: queryParam.status || undefined,
    },
  })

  return response?.data
}

export const resendCommand = async (payload, serverRegion) => {
  const response = await apiClient({
    method: 'POST',
    url: `${baseEndpoint}/command`,
    headers: regionHeaders(serverRegion),
    data: payload,
  })

  return response?.data
}

export const deleteCommand = async (payload, serverRegion) => {
  const response = await apiClient({
    method: 'DELETE',
    url: baseEndpoint,
    headers: regionHeaders(serverRegion),
    data: payload,
  })

  return response?.data
}
